/** 
 * @type {ComponentsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    component_type_ids: null,
    project_ids: null,
}
/** 
* @returns {ComponentsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/ComponentsFilter.js